<mat-card>

    <p>
        {{this.data.text}}
    </p>

</mat-card>
